import React from "react";

const BdIconicAbout = () => {
  const brandCyan = "#0ea5e9";
  const brandPurple = "#d946ef";

  return (
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif",
        color: "#1e293b",
        backgroundColor: "#ffffff",
        padding: "50px 0 70px",
        marginTop: "-50px",
      }}
    >
      <div style={{ maxWidth: "1440px", margin: "0 auto", padding: "0 20px" }}>
        {/* ================= 1. Hero / Header Section ================= */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "50px",
            alignItems: "center",
            marginBottom: "70px",
          }}
        >
          <div>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandCyan,
                letterSpacing: "1.2px",
                marginBottom: "10px",
                display: "block",
                textTransform: "uppercase",
              }}
            >
              ✦ ETHICAL MANPOWER & HUMAN RESOURCES
            </span>

            <h2
              style={{
                fontSize: "36px",
                lineHeight: "1.25",
                fontWeight: "800",
                color: "#0f172a",
                margin: "0 0 18px 0",
              }}
            >
              Connecting Talent With{" "}
              <span style={{ color: brandPurple }}>Opportunity</span>
            </h2>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.65",
                fontSize: "15px",
                marginBottom: "20px",
              }}
            >
              <strong style={{ color: brandCyan }}>BD Iconic</strong> is a
              premier global recruitment and manpower consultancy dedicated to
              providing Saudi Arabia and Middle Eastern enterprises with ethical
              recruitment, skilled manpower, and professional excellence.
            </p>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.65",
                fontSize: "15px",
                marginBottom: "28px",
              }}
            >
              Operating since 2010, we actively support mega-infrastructure
              projects and the strategic workforce requirements of Vision 2030
              through verified, pre-screened, and highly trained personnel.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "14px",
              }}
            >
              {[
                "100% Ethical Recruitment",
                "Saudi RL Licensed Agency",
                "Pre-Departure Skill Training",
                "Complete Medical & Visa Support",
              ].map((item, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#334155",
                  }}
                >
                  <span
                    style={{
                      color: brandPurple,
                      fontWeight: "800",
                      fontSize: "16px",
                    }}
                  >
                    ✓
                  </span>{" "}
                  {item}
                </div>
              ))}
            </div>
          </div>

          <div style={{ position: "relative" }}>
            <img
              src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=1200&q=85"
              alt="Global Workforce Meeting"
              style={{
                width: "100%",
                height: "380px",
                borderRadius: "16px",
                objectFit: "cover",
                display: "block",
                boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "-20px",
                left: "-20px",
                background: "#ffffff",
                padding: "16px 24px",
                borderRadius: "12px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                border: "1px solid #f1f5f9",
              }}
            >
              <span
                style={{
                  fontSize: "26px",
                  fontWeight: "800",
                  color: brandCyan,
                  display: "block",
                  lineHeight: "1",
                }}
              >
                15,000+
              </span>
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#64748b",
                }}
              >
                Personnel Deployed
              </span>
            </div>
          </div>
        </div>

        {/* ================= 2. Stats Bar ================= */}
        <div
          style={{
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
            padding: "32px 24px",
            borderRadius: "16px",
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "20px",
            marginBottom: "70px",
            textAlign: "center",
          }}
        >
          {[
            { value: "15,000+", label: "Workers Placed" },
            { value: "100%", label: "Ethical Compliance" },
            { value: "15+", label: "Years Experience" },
            { value: "200+", label: "Enterprise Partners" },
          ].map((stat, i) => (
            <div key={i}>
              <span
                style={{
                  fontSize: "32px",
                  fontWeight: "800",
                  color: brandPurple,
                  display: "block",
                  lineHeight: "1.1",
                  marginBottom: "4px",
                }}
              >
                {stat.value}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#64748b",
                }}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        {/* ================= 3. Core Pillars (4 Feature Boxes) ================= */}
        <div style={{ textAlign: "center", marginBottom: "36px" }}>
          <span
            style={{
              fontSize: "12px",
              fontWeight: "700",
              color: brandPurple,
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            WHY WORK WITH US
          </span>

          <h2
            style={{
              fontSize: "32px",
              fontWeight: "800",
              margin: "8px 0 0 0",
              color: "#0f172a",
            }}
          >
            Our Core <span style={{ color: brandCyan }}>Pillars</span>
          </h2>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "20px",
            marginBottom: "70px",
          }}
        >
          {[
            {
              title: "Compliance",
              desc: "Fully licensed and strictly adhering to international labor regulations, RL standards, and government protocols.",
            },
            {
              title: "Global Reach",
              desc: "Extensive talent acquisition network across Bangladesh and South Asia supplying verified workforce.",
            },
            {
              title: "Human Centric",
              desc: "Fair compensation, pre-departure training, and full welfare support for candidates throughout placement.",
            },
            {
              title: "Efficiency",
              desc: "Streamlined visa processing, thorough medical screening, and rapid mobilization for mega-projects.",
            },
          ].map((box, i) => (
            <div
              key={i}
              style={{
                background: "#ffffff",
                padding: "26px 20px",
                borderRadius: "14px",
                border: "1px solid #e2e8f0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
              }}
            >
              <h4
                style={{
                  margin: "0 0 10px 0",
                  color: brandPurple,
                  fontSize: "18px",
                  fontWeight: "700",
                }}
              >
                {box.title}
              </h4>
              <p
                style={{
                  margin: 0,
                  fontSize: "14px",
                  color: "#64748b",
                  lineHeight: "1.6",
                }}
              >
                {box.desc}
              </p>
            </div>
          ))}
        </div>

        {/* ================= 4. Sectors Supplied ================= */}
        <div style={{ marginBottom: "70px" }}>
          <div style={{ textAlign: "center", marginBottom: "36px" }}>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandCyan,
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              INDUSTRIES WE SERVE
            </span>

            <h2
              style={{
                fontSize: "32px",
                fontWeight: "800",
                margin: "8px 0 0 0",
                color: "#0f172a",
              }}
            >
              Workforce Expertise Across{" "}
              <span style={{ color: brandPurple }}>Sectors</span>
            </h2>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "20px",
            }}
          >
            {[
              "Civil Construction & Infrastructure",
              "Electro-Mechanical (MEP) Engineers",
              "Healthcare & Nursing Personnel",
              "Hospitality & Facilities Management",
              "Oil, Gas & Heavy Energy Industries",
              "Logistics, Supply Chain & Drivers",
            ].map((industry, idx) => (
              <div
                key={idx}
                style={{
                  padding: "18px 20px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  background: "#f8fafc",
                  fontSize: "15px",
                  fontWeight: "700",
                  color: "#334155",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: brandCyan,
                    display: "inline-block",
                  }}
                />
                {industry}
              </div>
            ))}
          </div>
        </div>

        {/* ================= 5. Light Gradient CTA Banner ================= */}
        <div
          style={{
            background: "linear-gradient(90deg, #0ea5e9 0%, #d946ef 100%)",
            padding: "40px",
            borderRadius: "16px",
            color: "#ffffff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div>
            <h3
              style={{
                margin: "0 0 8px 0",
                fontSize: "26px",
                fontWeight: "800",
                color: "#fff",
              }}
            >
              Partner with Industry Leaders
            </h3>
            <p style={{ margin: 0, fontSize: "15px", opacity: 0.95 }}>
              Accelerate your project timelines with reliable, skilled, and
              certified manpower.
            </p>
          </div>

          <button
            style={{
              background: "#ffffff",
              color: "#0f172a",
              border: "none",
              padding: "14px 28px",
              borderRadius: "8px",
              fontWeight: "700",
              cursor: "pointer",
              fontSize: "14px",
              whiteSpace: "nowrap",
            }}
          >
            Contact Us Now →
          </button>
        </div>
      </div>

      {/* Responsive Styles */}
      <style>
        {`
          @media (max-width: 1024px) {
            div[style*="gridTemplateColumns: 1fr 1fr"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="gridTemplateColumns: repeat(4, 1fr)"] {
              grid-template-columns: repeat(2, 1fr) !important;
            }
            div[style*="gridTemplateColumns: repeat(3, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
          }

          @media (max-width: 640px) {
            div[style*="gridTemplateColumns: repeat(4, 1fr)"],
            div[style*="gridTemplateColumns: repeat(2, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="justifyContent: space-between"] {
              flex-direction: column !important;
              align-items: flex-start !important;
            }
            h2 {
              font-size: 28px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default BdIconicAbout;
